import { render, staticRenderFns } from "./CTransitionExpand.vue?vue&type=template&id=04295d2f&scoped=true&"
import script from "./CTransitionExpand.vue?vue&type=script&lang=ts&"
export * from "./CTransitionExpand.vue?vue&type=script&lang=ts&"
import style0 from "./CTransitionExpand.vue?vue&type=style&index=0&id=04295d2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04295d2f",
  null
  
)

export default component.exports